import { createSlice } from '@reduxjs/toolkit'

const initialState = 
    {
        user: null,
        response: null,
        loading: false,
        error: null,
        callTimes: 0,
        message: '',
        data: []
    }

export const gamebidSlice = createSlice({
    name: 'gamebidSliceName',
    initialState,
    reducers: {
        getDashboardData: () => {
        },
        getGameBid: () => {
        },
        removeGameBid: () => {
        },
        updateGameBid: (state, action) => {
            state.value += action.payload
        },
        successGameBid: (state, action) => {
            console.log(state)
            state.data = action.payload
        },
        failedGameBid: (state, action) => {
            
            state.value += action.payload
        },
        gameBidWinnerCheck: () => {
            console.log('winnerCheck')
        }
    },
})

// Action creators are generated for each case reducer function
export const { getGameBid, removeGameBid, updateGameBid, successGameBid, failedGameBid, getDashboardData, gameBidWinnerCheck } = gamebidSlice.actions

export default gamebidSlice.reducer